import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { IAttachment } from '@common/interfaces/attachment';
import { ID } from '@common/interfaces/id';
import { AttachmentService } from '@ep-om/project/state/attachment/attachment.service';
import { UserQuery } from '@ep-om/project/state/user/user.query';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  selector: 'photo-modal',
  templateUrl: './photo-modal.component.html',
  styleUrls: ['./photo-modal.component.scss']
})
export class PhotoModalComponent implements OnInit {
  @ViewChild('background', { static: true, read: ElementRef }) background: ElementRef<HTMLDivElement>;
  issueId: ID;
  attachment: IAttachment;
  thumbnail: string;
  photo: string;
  isPortrait: boolean;
  canDelete: boolean;

  constructor(
    private _modalRef: NzModalRef,
    private attService: AttachmentService,
    public userQuery: UserQuery) { }

  checkClick(event) {
    if (event.target === this.background.nativeElement) {
      this.closeModal({ message: 'close' });
    }
  }

  async ngOnInit() {
    if (this.attachment.thumbnail) {
      this.thumbnail = this.attService.bufferToBase64(this.attachment.thumbnail);
      this.photo = await this.attService.getPhotoById(this.attachment.copyOf || this.attachment.cloneOf || this.attachment.id);
      const img = new Image();
      img.src = this.photo;
      this.isPortrait = img.width < img.height
    }
  }

  confirm() {
    this._modalRef.triggerOk();
  }

  closeModal(result: any) {
    this._modalRef.close(result);
  }

  downloadAttachment() {
    this.attService.downloadAttachment(this.attachment);
  }

  async openDeleteModal() {
    const res = await this.attService.openDeleteModal(this.attachment)
    if (res) {
      this.closeModal({ message: 'remove' });
    }
  }
}
